export const USER_INTERACTION = 'userInteraction';